/**
 * Site-wide notice bar.
 *
 * The bar is fixed, so Salient's header and the page content are offset by the
 * --os-notice-h custom property. NoticeBar::render() already measures the bar in
 * an inline script so the first paint is correct; this script keeps that value in
 * sync afterwards, when a resize changes the wrap count or the visitor dismisses
 * the bar.
 *
 * Dismissal is stored in localStorage under a key derived from the copy, so
 * editing the notice makes it reappear for visitors who dismissed the old one.
 */
(function () {
    'use strict';

    var bar = document.getElementById('os-notice');

    if (!bar) {
        return;
    }

    var root = document.documentElement;

    function syncHeight() {
        var height = bar.classList.contains('os-notice--dismissed') ? 0 : bar.offsetHeight;
        root.style.setProperty('--os-notice-h', height + 'px');
    }

    syncHeight();

    if ('ResizeObserver' in window) {
        new ResizeObserver(syncHeight).observe(bar);
    } else {
        window.addEventListener('resize', syncHeight);
    }

    var dismiss = bar.querySelector('.os-notice__dismiss');

    if (dismiss) {
        dismiss.addEventListener('click', function () {
            bar.classList.add('os-notice--dismissed');
            syncHeight();

            try {
                window.localStorage.setItem(bar.getAttribute('data-notice-key'), '1');
            } catch (e) {
                // Private browsing or a full quota — the bar still closes for this page view.
            }
        });
    }
})();
